import $ from 'jquery';

const PATHS = {
  login: '/users/sign_in',
  signup: '/users/sign_up',
};

function bindEyeToggle(scope) {
  scope.querySelectorAll('.fa-eye-slash, .fa-eye').forEach((icon) => {
    if (icon.dataset.bound) return;
    icon.dataset.bound = '1';
    icon.addEventListener('click', () => {
      const password = icon.parentElement.querySelector('input');
      if (!password) return;
      const isPassword = password.getAttribute('type') === 'password';
      password.setAttribute('type', isPassword ? 'text' : 'password');
      icon.classList.toggle('fa-eye', !isPassword);
      icon.classList.toggle('fa-eye-slash', isPassword);
    });
  });
}

function reloadAfterHide() {
  const modal = document.getElementById('authModal');
  if (modal) $(modal).modal('hide');
  setTimeout(() => window.location.reload(), 250);
}

function openAuthModal(mode) {
  const $modal = $('#authModal');
  const $body = $('#authModalBody');
  if (!$modal.length) return;

  $body.html('<div class="text-center text-muted py-5">Cargando…</div>');
  $modal.modal('show');

  $.ajax({
    url: PATHS[mode],
    method: 'GET',
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'text/html' },
  })
    .done((html) => {
      $body.html(html);
      bindForms($body[0]);
      bindOmniLinks($body[0]);
    })
    .fail(() => {
      $body.html('<div class="alert alert-danger">No se pudo cargar el formulario. Intenta de nuevo.</div>');
    });
}

function swapFormBody(xhr) {
  $('#authModalBody').html(xhr.responseText);
  const scope = $('#authModalBody')[0];
  bindForms(scope);
  bindOmniLinks(scope);
  bindResendLinks(scope);
}

function bindForms(scope) {
  bindEyeToggle(scope);

  const forms = scope.querySelectorAll('form[data-auth-modal]');
  forms.forEach((form) => {
    if (form.dataset.bound) return;
    form.dataset.bound = '1';

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      if (submit) submit.disabled = true;

      const xhr = $.ajax({
        url: form.action,
        method: (form.method || 'POST').toUpperCase(),
        data: $(form).serialize(),
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'text/html, application/json' },
      });

      xhr.then(
        (data, _textStatus, jqXHR) => {
          const ct = jqXHR.getResponseHeader('content-type') || '';
          if (ct.includes('application/json')) {
            let resp = data;
            if (typeof resp === 'string') {
              try { resp = JSON.parse(resp); } catch (err) { resp = {}; }
            }
            if (resp && resp.status === 'ok') {
              reloadAfterHide();
            } else {
              window.location.reload();
            }
          } else {
            window.location.reload();
          }
        },
        (jqXHR) => {
          if (submit) submit.disabled = false;
          const ct = jqXHR.getResponseHeader('content-type') || '';
          if (ct.includes('html')) {
            swapFormBody(jqXHR);
          } else {
            $('#authModalBody').html(
              '<div class="alert alert-danger">Ocurrió un error. Intenta de nuevo.</div>'
            );
          }
        }
      );
    });
  });
}

function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta ? meta.content : '';
}

function submitOmniForm(provider) {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = `/users/auth/${provider}`;
  form.style.display = 'none';

  const t = document.createElement('input');
  t.type = 'hidden';
  t.name = 'authenticity_token';
  t.value = csrfToken();
  form.appendChild(t);

  const o = document.createElement('input');
  o.type = 'hidden';
  o.name = 'origin';
  o.value = window.location.href;
  form.appendChild(o);

  document.body.appendChild(form);
  form.submit();
}

function bindOmniLinks(scope) {
  scope.querySelectorAll('[data-omniauth]').forEach((el) => {
    if (el.dataset.bound) return;
    el.dataset.bound = '1';
    el.addEventListener('click', (e) => {
      e.preventDefault();
      submitOmniForm(el.dataset.omniauth);
    });
  });
}

function bindResendLinks(scope) {
  scope.querySelectorAll('[data-resend-confirmation]').forEach((el) => {
    if (el.dataset.bound) return;
    el.dataset.bound = '1';
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const email = el.dataset.resendConfirmation;
      el.classList.add('disabled');
      el.textContent = 'Enviando…';

      $.ajax({
        url: '/users/confirmation',
        method: 'POST',
        data: { user: { email: email }, authenticity_token: csrfToken() },
        headers: { 'Accept': 'text/html' },
      }).always(() => {
        const banner = document.createElement('div');
        banner.className = 'alert alert-success text-center mt-2';
        banner.textContent = 'Si el email existe y no estaba confirmado, te enviamos un nuevo correo de activación.';
        el.replaceWith(banner);
      });
    });
  });
}

function bindTriggers() {
  document.querySelectorAll('[data-auth]').forEach((el) => {
    if (el.dataset.bound) return;
    el.dataset.bound = '1';
    el.addEventListener('click', (e) => {
      e.preventDefault();
      openAuthModal(el.dataset.auth);
    });
  });
  bindOmniLinks(document);
}

document.addEventListener('turbolinks:load', bindTriggers);
document.addEventListener('DOMContentLoaded', bindTriggers);
